import React from 'react'
import { Path } from 'react-native-svg'

import { genIcon } from './helper/gen'

const IconCoordOutline = genIcon({
  render: color => {
    return (
      <Path
        fill={color}
        fillRule="nonzero"
        d="M10.88 3.436a6.5 6.5 0 0 1 6.5 6.5c0 1.664-.901 3.485-2.666 5.544l1.114.001a2.25 2.25 0 0 1 .154 4.495l-.154.005h-9.01a.672.672 0 0 0-.099 1.336l.1.007h13.125a.75.75 0 0 1 .102 1.493l-.102.007H6.818a2.172 2.172 0 0 1-.155-4.337l.155-.006 3.234.002a1.508 1.508 0 0 1-.18-.14c-3.626-3.288-5.493-6.012-5.493-8.407a6.5 6.5 0 0 1 6.5-6.5zm2.44 13.544c-.443.444-.92.897-1.433 1.362a1.508 1.508 0 0 1-.18.14h4.12a.75.75 0 0 0 .103-1.494l-.102-.007zM10.88 4.936a5 5 0 0 0-5 5c0 1.841 1.666 4.273 5 7.295 3.333-3.022 5-5.454 5-7.295a5 5 0 0 0-5-5zm0 1.5a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7zm0 1.5a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
      />
    )
  },
})

export default IconCoordOutline
